import { css } from "lit";

// The client's palette and type, as custom properties on a page's host element, after Moxfield's
// dark theme: flat charcoal, Inter, lavender for links and what you can act on, purple for the
// brand, and its playtester's orange and blue pills for game actions.
export const palette = css`
  :host {
    --bg: #1b1b1b;
    --surface: #222222;
    --surface-2: #2b2b2b;
    --surface-3: #333333;
    --input: #111111;
    --border: #333333;
    --border-strong: #444444;
    --grid: #262626;
    --text: #dddddd;
    --text-strong: #ffffff;
    --text-dim: #aaaaaa;
    --text-faint: #7c7c7c;
    --brand: #731fa1;
    --brand-hi: #8b2fc0;
    --lavender: #c999e6;
    --lavender-soft: rgb(201 153 230 / 0.16);
    --tag: #665599;
    --ask: #f0883e;
    --action-orange: linear-gradient(#e67b3b 0%, #df6834 40%, #d8a055 100%);
    --action-orange-edge: #c26d42;
    --action-orange-glow: #71241e;
    --action-orange-shine: #ffe1a3;
    --action-blue: linear-gradient(#475ddd 0%, #3c53e6 40%, #7a97df 100%);
    --action-blue-edge: #475ad1;
    --action-blue-glow: #3039aa;
    --action-blue-shine: #9aaef5;
    --good: #3ec46d;
    --good-soft: rgb(62 196 109 / 0.16);
    --bad: #e5484d;
    --bad-soft: rgb(229 72 77 / 0.16);
    --warn: #feb56a;
    --warn-soft: rgb(254 181 106 / 0.16);
    --mana-w: #f8f6d8;
    --mana-u: #c1d7e9;
    --mana-b: #bab1ab;
    --mana-r: #e49977;
    --mana-g: #a3c095;
    --mana-c: #cac5c0;
    --font-ui: "Inter", system-ui, -apple-system, "Segoe UI", sans-serif;
    --ease-out: cubic-bezier(0.22, 1, 0.36, 1);
  }
`;

// What acts shows the page's actionable pointer (click-feedback), under any rule a component sets.
export const cursors = css`
  :where(a[href], button:not(:disabled), summary, select:not(:disabled), input[type="checkbox"]:not(:disabled),
    input[type="radio"]:not(:disabled), label:has(input:not(:disabled))) {
    cursor: var(--cursor-pointer, pointer);
  }
`;
